$(document).ready(function () {
  // Share list

  $('.share-list').each(function () {
    const shareList = $(this)
    const shareBtn = shareList.find('.network-button')
    const shareOptions = shareList.find('li').not(':first').find('a, button')

    // Avoid tab navigation in social media buttons
    shareOptions.attr('tabindex', '-1')

    shareBtn.on('click', function () {
      shareList.toggleClass('active')
      // Toggle aria-expanded attribute
      $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true')

      // Allow tab navigation in social media buttons (toggle attribute value)
      shareOptions.attr('tabindex', shareOptions.attr('tabindex') === '0' ? '-1' : '0')
    })

    // Close share list when clicking anywhere else
    $('html').click(function (e) {
      if (!$(e.target).hasClass('share-list') && !$(e.target).hasClass('network-button')) {
        $('.share-list').removeClass('active')

        // change aria-expanded attribute to false
        $('.share-list .network-button').attr('aria-expanded', 'false')

        // Avoid tab navigation in social media buttons
        shareOptions.attr('tabindex', '-1')
      }
    })
  })

  copyPageUrlToClipBoard()
})

function copyPageUrlToClipBoard () {
  const buttonClipboard = document.getElementsByClassName('share-list--link')

  $('.share-list--link').on('click', function () {
    const url = $(this).attr('value')
    navigator.clipboard.writeText(url)
  })
}
